import { Component, input, output } from '@angular/core';

/**
 * Componente atom para exibir um item individual de completude do perfil.
 *
 * Exibe o status de um item (completo ou pendente) com ícone e label traduzido.
 * Flexível para ser usado em qualquer nível de completude.
 *
 * @example
 * <lib-profile-completion-item
 *   [completed]="true"
 *   [label]="'profile-score.items.email' | translate"
 *   [linkLabel]="'profile-score.how_to_connect' | translate"
 *   (linkClicked)="handleLinkClick()"
 * />
 */
@Component({
  standalone: true,
  selector: 'lib-profile-completion-item',
  templateUrl: './profile-completion-item.component.html',
  styleUrls: ['./profile-completion-item.component.scss'],
})
export class ProfileCompletionItemLibComponent {
  /**
   * Se o item está completo (true) ou pendente (false)
   */
  completed = input.required<boolean>();

  /**
   * Label traduzido para exibir ao usuário
   * Use com translate: [label]="'profile-score.items.email' | translate"
   */
  label = input.required<string>();

  /**
   * Label opcional para o link de ação (ex: "Como conectar?", "Como ativar?")
   * Quando presente, exibe um link clicável ao lado do label
   */
  linkLabel = input<string>();

  /**
   * Evento emitido quando o link de ação é clicado
   * Use para abrir modais ou executar ações específicas
   */
  readonly linkClicked = output<void>();
}
